import CustomMarks from '@/services/rest/bemob/custom-marks';

export class AddMarksApi {
  customMarksApi: CustomMarks = new CustomMarks();

  loading: boolean = false;
  error: boolean = false;

  // put(data: Bemob.Campaign) {
  //   this.loading = true;

  //   return this.customMarksApi.postCreate(data).then((payload: any) => {
  //     this.data = payload;
  //     this.loading = false;
  //     return payload;
  //   }).finally(() => {
  //     this.loading = false;
  //   });
  // }

  put(payload: Bemob.CustomMark) {
    this.loading = true;

    return this.customMarksApi.put(payload).then((payload) => {
      this.loading = false;
      return payload;
    }).finally(() => {
      this.loading = false;
    })
  }

  putBasic(path: string, payload: Bemob.CustomMarkBase) {
    this.loading = true;

    return this.customMarksApi.putBasic(path, payload).then((payload) => {
      this.loading = false;
      return payload;
    }).finally(() => {
      this.loading = false;
    })
  }
}

export default new AddMarksApi();
